// extracted by mini-css-extract-plugin
export default {"IconButton":"IconButton_IconButton__a-6m6","IconButton--disabled":"IconButton_IconButton--disabled__igMvQ","IconButton-title":"IconButton_IconButton-title__97VjR"};